<template lang="pug">
v-content
  v-toolbar.page-header(app, flat, fixed, color='white', height='105')
    v-breadcrumbs(divider='/')
      v-breadcrumbs-item
        h2 Profile
    v-spacer
    v-btn.page-header__action(:to="`/profile/edit`", exact='', color='primary') Edit


  v-container.pa-0(fluid)
    v-layout(row, nowrap)
      v-flex
        .pb-3
          .section__title.mb-5
            .subheading
              | Info
          v-layout(row)
            v-flex(md3)
              label.pl-0 Name
            v-flex(md6)
              p {{ C.data.profile.firstname }} {{ C.data.profile.lastname }}

          v-layout(row)
            v-flex(md3)
              label.pl-0 Email
            v-flex(md6)
              p {{ C.data.profile.email }}

          v-layout(row, v-if='C.data.profile.citizenship')
            v-flex(md3)
              label.pl-0 Citizenship
            v-flex(md6)
              p {{ C.list.countries[C.data.profile.citizenship] && C.list.countries[C.data.profile.citizenship].name }}

          v-layout(row, v-if='C.data.profile.time_zone')
            v-flex(md3)
              label.pl-0 Time Zone
            v-flex(md6)
              p {{ C.data.profile.time_zone }}


        .pb-5(v-if='C.data.profile.home_address')
          .section__title.mb-5
            .subheading
              | Home Address

          v-layout(row, v-if='C.data.profile.home_address.street1')
            v-flex(md3)
              label.pl-0 Street Address
            v-flex(md6)
              p
                | {{ C.data.profile.home_address.street1 }}
              p(v-if='C.data.profile.home_address.street2')
                | {{ C.data.profile.home_address.street2 }}

          v-layout(row, v-if='C.data.profile.home_address.city')
            v-flex(md3)
              label.pl-0 City
            v-flex(md6)
              p
                | {{ C.data.profile.home_address.city }}

          v-layout(row, v-if='C.data.profile.home_address.state_province')
            v-flex(md3)
              label.pl-0 State/Province
            v-flex(md6)
              p
                | {{ C.data.profile.home_address.state_province }}

          v-layout(row, v-if='C.data.profile.home_address.postal_code')
            v-flex(md3)
              label.pl-0 Postal Code
            v-flex(md6)
              p
                | {{ C.data.profile.home_address.postal_code }}

          v-layout(row, v-if='C.data.profile.home_address.country')
            v-flex(md3)
              label.pl-0 Country
            v-flex(md6)
              p
                | {{ C.list.countries[C.data.profile.home_address.country] && C.list.countries[C.data.profile.home_address.country].name }}

          v-layout(row v-if='C.data.profile.home_address.phone_number')
            v-flex(md3)
              label.pl-0 Phone Number
            v-flex(md6)
              p {{ C.data.profile.home_address.phone_number }}

        .pb-5(v-if='C.data.profile.work_address')
          .section__title.mb-5
            .subheading
              | Work Address

          v-layout(row, v-if='C.data.profile.work_address.street1')
            v-flex(md3)
              label.pl-0 Street Address
            v-flex(md6)
              p
                | {{ C.data.profile.work_address.street1 }}
              p(v-if='C.data.profile.work_address.street2')
                | {{ C.data.profile.work_address.street2 }}

          v-layout(row, v-if='C.data.profile.work_address.city')
            v-flex(md3)
              label.pl-0 City
            v-flex(md6)
              p
                | {{ C.data.profile.work_address.city }}

          v-layout(row, v-if='C.data.profile.work_address.state_province')
            v-flex(md3)
              label.pl-0 State/Province
            v-flex(md6)
              p
                | {{ C.data.profile.work_address.state_province }}

          v-layout(row, v-if='C.data.profile.work_address.state_province')
            v-flex(md3)
              label.pl-0 Postal Code
            v-flex(md6)
              p
                | {{ C.data.profile.work_address.postal_code }}

          v-layout(row, v-if='C.data.profile.work_address.country')
            v-flex(md3)
              label.pl-0 Country
            v-flex(md6)
              p
                | {{ C.list.countries[C.data.profile.work_address.country] && C.list.countries[C.data.profile.work_address.country].name }}

          v-layout(row v-if='C.data.profile.work_address.phone_number')
            v-flex(md3)
              label.pl-0 Phone Number
            v-flex(md6)
              p {{ C.data.profile.work_address.phone_number }}

        .pb-5(v-if='C.data.profile.work_address')
          .section__title.mb-5
            .subheading
              | Organizations

          v-layout(row, no-wrap, align-center, v-if='C.data.profile.organizations && C.data.profile.organizations.length > 0', v-for='organizationStatusItem in C.data.profile.user_organization_statuses', :key='organizationStatusItem.organization_id')
            v-flex
              v-card-title.pa-0.pt-2
                h3 {{ organizationStatusItem.organization_name }}
              v-card-text.pl-0.pt-2
                v-layout(row, wrap, align-center)
                  p(v-if='organizationStatusItem.status')
                    label.mr-2
                      | Status:
                    | {{ organizationStatusItem.status }}
                  p(v-if='organizationStatusItem.title && organizationStatusItem.oa')
                    span.px-3 &bull;
                    label.mr-2
                      | Title:
                    | {{ organizationStatusItem.title }}
                  p(v-if='organizationStatusItem.phone && organizationStatusItem.oa')
                    span.px-3 &bull;
                    label.mr-2
                      | Phone:
                    | {{ organizationStatusItem.phone }}
                  p(v-if='organizationStatusItem.oa')
                    span.px-3 &bull;
                    v-icon.mr-1(small, color='secondary') person
                    | Org Admin
</template>

<script>
  import tools from '../../assets/tools.js'
  import countryData from 'country-data'

  export default {
    data () {
      return {
        C: {
          data: {
            profile: {}
          },
          list: {
            countries: countryData.countries
          }
        }
      }
    },
    created () {
      var component = this

      tools.loggedInData({
        success: function (loggedInItem) {
          component.C.data.profile = (loggedInItem && loggedInItem.data) || {}
        },
        error: function (errorResponse) {
          tools.alert({
            type: 'error',
            errorResponse: errorResponse
          })
        }
      })
    }
  }
</script>



<style scoped>
  .media {
      height: 100%;
      margin: 0;
  }
  .side-drawer {
    background-color: transparent;
  }
</style>



// WEBPACK FOOTER //
// src/components/User/Profile.vue